import { Spin } from "antd";
import { LocaleProvider } from "antd";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import "moment/locale/zh-cn";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Loadable from "react-loadable";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { getAppTitle } from "utils/app";
import * as serviceWorker from "./serviceWorker";

import AuthenticatedLayout from "layouts/authenticated";
import Login from "layouts/login";
import PublicLayout from "layouts/public";
import UserStore from "stores/user";

/**
 * react-loadable 加载效果
 */
function Loading() {
  return <div className="mts-container-light" style={{ textAlign: "center", padding: 50 }}><Spin /></div>;
}

const AsyncAudioClipper = Loadable({ loader: () => import("routers/audioClipper"), loading: Loading });
const AsyncAudioClipperFragment = Loadable({ loader: () => import("routers/audioClipper/fragment"), loading: Loading });
const AsyncAudios = Loadable({ loader: () => import("routers/audios"), loading: Loading });
const AsyncCompareFeatures = Loadable({ loader: () => import("routers/compareFeatures/settings"), loading: Loading });
const AsyncAudioEditor = Loadable({ loader: () => import("routers/audios/editor"), loading: Loading });
const AsyncHelp = Loadable({ loader: () => import("routers/help"), loading: Loading });
const AsyncHome = Loadable({ loader: () => import("routers/home"), loading: Loading });
const AsyncAudioProjects = Loadable({ loader: () => import("routers/projects"), loading: Loading });
const AsyncVideoClipper = Loadable({ loader: () => import("routers/videoClipper"), loading: Loading });
const AsyncVideos = Loadable({ loader: () => import("routers/videos"), loading: Loading });
const AsyncShare = Loadable({ loader: () => import("routers/share"), loading: Loading });
const AsyncTask = Loadable({ loader: () => import("routers/tasks"), loading: Loading });
const AsyncDemo = Loadable({ loader: () => import("routers/demo"), loading: Loading });

const user = new UserStore();
ReactDOM.render(
  <LocaleProvider locale={zh_CN}>
    <Router>
      <Switch>
        <Route exact={true} path="/account/login" render={(route) => <Login route={route} />} />

        <Route exact={true} path="/" render={
          (route) => <AuthenticatedLayout component={AsyncHome} route={route} user={user} />
        } />

        <Route exact={true} path="/help/:category" render={
          (route) => <AuthenticatedLayout component={AsyncHelp} route={route} title={"帮助"} user={user} />
        } />

        <Route exact={true} path="/audios" render={
          (route) => <AuthenticatedLayout component={AsyncAudios} route={route} user={user} />
        } />

        <Route exact={true} path="/comparefeatures/settings" render={
          (route) => <AuthenticatedLayout component={AsyncCompareFeatures} route={route} user={user} />
        } />

        <Route exact={true} path="/audios/multitrack" render={
          (route) => <AuthenticatedLayout component={AsyncAudioProjects} route={route} title={"多轨音频编辑"} user={user} />
        } />

        <Route exact={true} path="/audios/editor/:id" render={
          (route) => <AuthenticatedLayout component={AsyncAudioEditor} route={route} title={"多轨音频编辑"} user={user} />
        } />

        <Route exact={true} path="/audioprojects" render={
          (route) => <AuthenticatedLayout component={AsyncAudioProjects} route={route} title={"音频工程夹"} user={user} />
        } />

        <Route exact={true} path="/audios/clipper" render={
          (route) => <AuthenticatedLayout component={AsyncAudioClipper} route={route} user={user} />
        } />

        <Route exact={true} path="/audios/clipper/fragment" render={
          (route) => <PublicLayout component={AsyncAudioClipperFragment} route={route} user={user} />
        } />

        <Route exact={true} path="/videos" render={
          (route) => <AuthenticatedLayout component={AsyncVideos} route={route} title={"电视收录及片段选用"} user={user} />
        } />

        <Route exact={true} path="/videos/clipper" render={
          (route) => <AuthenticatedLayout component={AsyncVideoClipper} route={route} user={user} />
        } />

        <Route exact={true} path="/shuazhibo/videos" render={
          (route) => <AuthenticatedLayout component={AsyncVideos} route={route} title={"融媒直播录像剪辑"} user={user} />
        } />

        <Route exact={true} path="/share/:id" render={
          (route) => <PublicLayout component={AsyncShare} route={route} />
        } />

        <Route exact={true} path="/tasks" render={
          (route) => <PublicLayout component={AsyncTask} route={route} />
        } />

        <Route exact={true} path="/demo" render={
          (route) => <AuthenticatedLayout component={AsyncDemo} route={route} user={user} />
        } />

        <Route component={AsyncHome} />
      </Switch>
    </Router>
  </LocaleProvider>,
  document.getElementById("root") as HTMLElement
);

(async () => {
  const favicon: any = document.querySelector("#favicon");
  if (favicon) {
    favicon.href = process.env.REACT_APP_FAVICON || "//mts.muzhiyun.cn/favicon.ico?origin=" + (window.location.hostname.match(/.*(?=media)/) || [""])[0];
  }

  const title = document.querySelector("title");
  if (title && title.text === "") {
    title.text = process.env.REACT_APP_TITLE || (await getAppTitle());
  }
})();

serviceWorker.register();
